import styled, { css } from "styled-components";
import { Color, ColorV2 } from "config/colors";
import { Link } from "react-router-dom";
import { PageContainer } from "components/designV2/layout/grid";

export const NavBarFrame = styled(PageContainer)<{ $isStampClockRoute: boolean }>`
  position: relative;
  /* Prevent margin-collapsing from route containers from pushing navbar down. */
  min-height: 1px;

  ${(props) =>
    props.$isStampClockRoute &&
    css`
      max-width: none;
      width: 100%;
      margin: 0;
    `}
`;

export const NavBarStyled = styled.nav<{ $isStampClockRoute: boolean }>`
  align-items: center;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 99;

  ${(props) =>
    props.$isStampClockRoute &&
    css`
      padding: 12px clamp(20px, 4vw, 44px);

      @media (max-width: 1180px) and (orientation: portrait) {
        /* Keep a visible blue inset on the right side in portrait too. */
        padding-right: clamp(30px, 7vw, 56px);
      }
    `}
`;

export const Burger = styled.div`
  margin: 0 20px 0 15px;

  @media (min-width: 1000px) {
    display: none;
  }
`;

export const ChatIconWrapper = styled.div`
  position: relative;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const ChatButton = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0 15px;
  position: relative;
`;

export const Flex1 = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: flex-end;
`;

export const ActionsWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  margin-left: 32px;
`;

export const ChatBlob = styled(ChatButton)`
  align-items: center;
  background-color: ${ColorV2.White};
  border-radius: 24px;
  box-shadow: none;
  display: flex;
  height: 64px;
  justify-content: center;
  padding: 0 20px;
`;

export const LogInWrapper = styled.li`
  align-items: center;
  display: none;
  flex-direction: row;
  justify-content: center;
  margin: 0 20px 0 15px;
  white-space: nowrap;

  @media (min-width: 1000px) {
    display: flex;
  }
`;

export const CompanyImage = styled.img`
  border-radius: 50%;
  box-shadow: 0 0 10px 0 rgba(185, 185, 185, 0.3);
  height: 30px;
  margin: 0 8px;
  object-fit: cover;
  width: 30px;
`;

export const SelectCompanyWrapper = styled.div`
  padding: 8px;
  width: 200px;

  p {
    margin-left: 8px;
  }
`;

export const OptionsWrapper = styled.div`
  background-color: ${Color.White};
  border-radius: 8px;
  box-shadow: 0 4px 15px 0 rgba(185, 185, 185, 0.5);
  position: absolute;
  right: 20px;
  width: 230px;
`;

export const Option = styled.div`
  align-items: center;
  border-bottom: 1px solid ${Color.SeaBlue200};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 230px;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const CompanyOption = styled(Option)`
  background-color: ${Color.SeaBlue200};
  border-bottom: 1px solid ${Color.White};
  flex-wrap: nowrap;

  p {
    white-space: normal;
  }
`;

export const LoginLink = styled(Link)`
  color: ${Color.MidnightBlue};
  text-decoration: none;
`;

export const Spacer = styled.div`
  flex: 1;
`;
